module.exports = __webpack_public_path__ + "img/Shuai Wang.3638b602.jpg";